import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Shell, StatCard } from "./_shell";

export default function Overview() {
  const [s, setS] = useState(null);
  const [lowStockCount, setLowStockCount] = useState(0);
  useEffect(() => {
    api.get("/admin/stats").then(r => setS(r.data)).catch(() => {});
    api.get("/admin/low-stock").then(r => setLowStockCount(r.data?.count || 0)).catch(() => {});
  }, []);
  return (
    <Shell active="overview">
      <div className="p-5 md:p-10">
        <div className="overline mb-2">Admin</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-10">Overview.</h1>
        {lowStockCount > 0 && (
          <Link to="/admin/low-stock" className="block mb-6 border-2 border-soda bg-soda/5 p-4 md:p-5 hover:bg-soda/10 transition-colors" data-testid="overview-lowstock-alert">
            <div className="overline text-soda mb-1">⚑ Restock alert</div>
            <div className="text-lg font-bold">{lowStockCount} product{lowStockCount === 1 ? "" : "s"} at or below low-stock threshold</div>
            <div className="text-xs text-black/60 mt-1">Click to view the reorder list →</div>
          </Link>
        )}
        {s && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <StatCard label="Products" value={s.products_total} testid="stat-products" />
            <StatCard label="Categories" value={s.categories_total} testid="stat-categories" />
            <StatCard label="Brands" value={s.brands_total} testid="stat-brands" />
            <StatCard label="Enquiries" value={`${s.enquiries_open || 0}/${s.enquiries_total || 0}`} testid="stat-enquiries" />
            <StatCard label="Retailers" value={s.retailers_total} testid="stat-retailers" />
            <StatCard label="Pending" value={s.retailers_pending} testid="stat-pending" />
            <StatCard label="Contact msgs" value={s.inquiries_total} testid="stat-inquiries" />
            <StatCard label="Approved" value={s.retailers_approved} testid="stat-approved" />
          </div>
        )}
      </div>
    </Shell>
  );
}
